import {
    Button,
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    Grid,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Stack,
    Switch,
    TextField,
    Typography,
} from '@mui/material';
import {useCallback, useEffect, useState} from 'react';
import axios from 'axios';
import {DatePicker} from '@mui/x-date-pickers';
import {parseISO} from 'date-fns';
import server from '../../../global/server';
import {Close} from '@mui/icons-material';
import useHandleErrors from '../../../hooks/useHandleErrors';
import {useSnackbar} from 'notistack';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import {LoadingButton} from '@mui/lab';
import {useFetch} from '../../../hooks/useFetch';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo obrigatório'),
    // holder_name: Yup.string().required('Campo obrigatório'),
    document: Yup.string().required('Campo obrigatório'),
    //document_type: Yup.string().required('Campo obrigatório'),
    email: Yup.string().email().required('Campo obrigatório'),
});

export default function PersonFormEdit({
    data,
    mutateList,
    setViewDialog,
    setEditCustomer,
    handleClose,
}) {
    const {enqueueSnackbar} = useSnackbar();
    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    useEffect(() => {
        if (data) {
            setValues(data, true);
        }
    }, [data]);
    const {
        handleChange,
        handleSubmit,
        handleReset,
        setFieldValue,
        handleBlur,
        setFieldError,
        setValues,
        values,
        errors,
        isSubmitting,
        setSubmitting,
    } = useFormik({
        initialValues: {
            name: '',
            document_type: '',
            phone: '',
            zipcode: '',
            address: '',
            complement: '',
            email: '',
            document: '',
            voluntary: false,
        },
        validationSchema: validationSchema,
        onSubmit: async (values, {setSubmitting}) => {
            try {
                setSubmitting(true);
                if (Boolean(values.id)) {
                    const {data} = await server.put(`/professional`, values);
                    enqueueSnackbar('Dados alterados');
                }

                // else {
                //     const {data} = await server.post('/person', values);
                //     setEditCustomer(data.data.id);
                //     enqueueSnackbar('Pessoa adicionada');
                // }
                setSubmitting(false);
                await mutateList();
            } catch (error) {
                console.log(error);
                setSubmitting(false);
                setErrs(error);
            }
        },
    });

    const handleDelete = async id => {
        try {
            await server.delete(`/person/${data.id}`);
            await mutateList();
            handleClose();
            enqueueSnackbar('Pessoa removida');
        } catch (error) {
            setSubmitting(false);
            setErrs(error);
        }
    };

    const [searchingZipCode, setSearching] = useState(false);
    const searchPostalCode = useCallback(
        async e => {
            try {
                handleBlur(e);
                setSearching(true);
                if (String(values?.zipcode).length === 8) {
                    const {data} = await axios.get(
                        `https://viacep.com.br/ws/${values.zipcode}/json/`,
                    );

                    if (data.erro) throw 'Erro';

                    setFieldValue(
                        'address',
                        `${data.logradouro}, ${data.bairro}, ${data.localidade}-${data.uf}`,
                    );

                    setSearching(false);
                }
            } catch (error) {
                setSearching(false);
                setFieldError('zipcode', 'CEP Inválido');
            }
        },
        [values],
    );

    return (
        <>
            {/* <Stack direction="row" justifyContent="space-between" alignItems="center">
                <DialogTitle>Empresa</DialogTitle>
                <IconButton
                    onClick={() => {
                        handleReset();
                        handleClose();
                    }}>
                    <Close />
                </IconButton>
            </Stack>
            <Divider /> */}
            <DialogContent>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.name}
                            InputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.name}
                            fullWidth
                            name="name"
                            label="Nome do cliente"
                            error={Boolean(errors.name)}
                        />
                    </Grid>

                    <Grid item xs={10}>
                        <TextField
                            required
                            helperText={errors.professional_number}
                            InputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.professional_number}
                            fullWidth
                            name="professional_number"
                            label="Documento profissional"
                            error={Boolean(errors.professional_number)}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            required
                            helperText={errors.professional_number_ext}
                            InputProps={{
                                maxLength: 2,
                            }}
                            onChange={handleChange}
                            value={values.professional_number_ext}
                            fullWidth
                            name="professional_number_ext"
                            label="UF"
                            error={Boolean(errors.professional_number_ext)}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <DatePicker
                            variant="outlined"
                            sx={{width: '100%'}}
                            required
                            timezone="America/Sao_Paulo"
                            format="dd/MM/yyyy"
                            label="Data de nascimento"
                            name="birthday"
                            onChange={e => setFieldValue('birthday', new Date(e))}
                            onBlur={handleBlur}
                            value={values.birthday ? new Date(values.birthday) : undefined}
                            error={Boolean(errors.birthday)}
                            helperText={errors.birthday}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl error={Boolean(errors.gender)}>
                            <FormLabel id="demo-row-radio-buttons-group-label">Sexo</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group">
                                <FormControlLabel
                                    control={
                                        <Radio
                                            onChange={handleChange}
                                            checked={values.gender === 'male'}
                                            name="gender"
                                            value="male"
                                        />
                                    }
                                    label="Masculino"
                                />
                                <FormControlLabel
                                    control={
                                        <Radio
                                            onChange={handleChange}
                                            checked={values.gender === 'female'}
                                            name="gender"
                                            value="female"
                                        />
                                    }
                                    label="Feminino"
                                />
                            </RadioGroup>
                        </FormControl>
                        <FormHelperText error={Boolean(errors.gender)}>
                            {errors.gender}
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.document}
                            onChange={handleChange}
                            value={values.document}
                            fullWidth
                            name="document"
                            label="Documento (CPF ou CPNJ)"
                            InputProps={{maxLength: 14}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.phone}
                            onChange={handleChange}
                            value={values.phone}
                            fullWidth
                            type="phone"
                            name="phone"
                            label="Telefone (DDD + Telefone)"
                            InputProps={{maxLength: 11}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            helperText={errors.email}
                            onChange={handleChange}
                            value={values.email}
                            fullWidth
                            name="email"
                            type="email"
                            label="E-mail"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {/* <TextField
                    required
                    helperText={errors.zipcode || values.address}
                    inputProps={{
                        maxLength: 30,
                    }}
                    onChange={handleChange}
                    value={values.zipcode}
                    fullWidth
                    name="zipcode"
                    label="CEP"
                    InputProps={{ maxLength: 7 }}
                /> */}
                        <TextField
                            variant="outlined"
                            fullWidth
                            required
                            label="CEP"
                            //type="number"
                            name="zipcode"
                            onChange={handleChange}
                            onBlur={searchPostalCode}
                            value={values.zipcode}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment>
                                        {searchingZipCode && (
                                            <CircularProgress disableShrink={true} size={15} />
                                        )}
                                    </InputAdornment>
                                ),
                            }}
                            error={Boolean(errors.zipcode) || Boolean(errors.address)}
                            helperText={
                                Boolean(errors.zipcode) || Boolean(errors.address)
                                    ? errors.zipcode || errors.address
                                    : Boolean(values.address)
                                    ? `${values.address}`
                                    : ''
                            }
                        />
                    </Grid>
                    <Grid item xs={10}>
                        <TextField
                            required
                            helperText={errors.complement}
                            InputProps={{
                                maxLength: 30,
                            }}
                            onChange={handleChange}
                            value={values.complement}
                            fullWidth
                            name="complement"
                            label="Complemento"
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            required
                            helperText={errors.number}
                            type="number"
                            onChange={handleChange}
                            value={values.number}
                            fullWidth
                            name="number"
                            label="Número"
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={values.voluntary}
                                    name="voluntary"
                                    inputProps={{'aria-label': 'controlled'}}
                                    onChange={(e, value) => setFieldValue('voluntary', value)}
                                />
                            }
                            label={values.voluntary ? 'Voluntário' : 'Involuntário'}
                        />
                    </FormGroup>
                </Grid>
                {/* <CustomerForm
                    values={values}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                    errors={errors}
                /> */}
            </DialogContent>
            <Divider />
            <DialogActions>
                {values.id && (
                    <Button
                        color="error"
                        onClick={e =>
                            window.confirm('Você tem certeza?') && handleDelete(values.id)
                        }>
                        Excluir
                    </Button>
                )}
                <Button onClick={e => setViewDialog(false)}>Cancelar</Button>
                <LoadingButton
                    loading={isSubmitting}
                    disabled={Boolean(Object.keys(errors).length)}
                    onClick={handleSubmit}>
                    Salvar
                </LoadingButton>
            </DialogActions>
        </>
    );
}

// export default function PersonForm({person_id}){

//     const {data, mutate, isLoading, error} = useFetch(`person/${person_id}`)

//     if(isLoading) return <CircularProgress />
//     if(error) return <Typography>{error.message}</Typography>

//     return <>
//         <PersonFormEdit data={data} />
//     </>
// }
